module.exports = __webpack_public_path__ + "img/广州办公室 (2).85fc9a46.jpg";